module.exports = __webpack_public_path__ + "static/media/league-nav-leaderboard.8b6595d9.svg";